import { useEffect } from 'react';

import { getSourceEventParams, useAmplitude } from '@crehana/analytics';
import { useTranslation } from '@crehana/i18n';
import { NextSeo } from 'next-seo';

import { VwoScript } from '@/shared/components/ThirdParty';
import { usePageView } from '@/shared/hooks';
import usePersistQueryParams from '@/shared/hooks/usePersistQueryParams';
import B2BLandingDefaultSeo from '@/views/B2BLanding/B2BLandingDefaultSeo';
import useTrustPulseNotification from '@/views/B2BLanding/hooks/useTrustPulseNotification/useTrustPulseNotification';

import { AMPLITUDE_TRACKS } from '../../events';
import localeViewEs from '../../i18n/localeEs';
import localeViewPt from '../../i18n/localePt';
import Header from './components/Header';
import SocialNotification from './components/SocialNotification';
import { PAGE_KEY } from './contants';
import GlobalStyles from './globalStyles';
import localeEs from './i18n/localeEs';
import localePt from './i18n/localePt';
import TrialFormSection from './sections/TrialFormSection';

const App = () => {
  usePersistQueryParams();
  const { openTrustPulse, trustPulseCompany } = useTrustPulseNotification({});
  const { t, addResourceBundle } = useTranslation();
  const { logEvent } = useAmplitude();
  addResourceBundle(
    {
      es: { [PAGE_KEY]: { ...localeEs.es, ...localeViewEs.es } },
      pt: { [PAGE_KEY]: { ...localePt.pt, ...localeViewPt.pt } },
    },
    { injectOnce: true },
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(() => {
    logEvent({
      event: AMPLITUDE_TRACKS.FORM_VIEWED,
      data: {
        ...getSourceEventParams(),
        Product: 'B2B',
        pageSlug: 'prueba-gratis',
        LandingName: 'Form Free Trial',
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  usePageView({ type: 'page' });

  return (
    <div className="bg-evelate-dark-00dp">
      <B2BLandingDefaultSeo />
      <VwoScript />
      <NextSeo
        title={t('PAGE_TITLE')}
        description={t('PAGE_DESCRIPTION')}
        canonical="/business/prueba-gratis/"
        openGraph={{
          title: `${t('PAGE_TITLE')} | ${t('CREHANA_FOR_BUSINESS')}`,
          description: t('PAGE_DESCRIPTION'),
        }}
      />
      <GlobalStyles />
      <Header />
      <TrialFormSection />
      <SocialNotification
        open={openTrustPulse === trustPulseCompany?.id}
        company={trustPulseCompany}
      />
    </div>
  );
};

export default App;
